<router-outlet></router-outlet>

<app-new-version-popup [open]="versionService.showUpdatePopup()" />
